import React from 'react';
import Immutable from 'immutable';

import {
  Button,
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphTextImage = ({ id, entity, wide }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkTarget = entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');
  const body = entity.getIn(['field_body', 0, 'processed']);
  const image = entity.getIn(['field_media_item', 0], Immutable.List());
  const imageSrc = image.getIn(['styles', 'paragraph_text_and_image']);
  const imageOriginalScaled = image.getIn(['styles', 'image_orignal_scaled']);
  const imageCaption = image.getIn(['entity', 'field_caption', 0, 'value'], null);
  const caption = entity.getIn(['field_caption', 0, 'value'], null);
  const flipped = entity.getIn(['field_flipped', 0, 'value']);
  const displayInOrginalRatio = entity.getIn(['field_display_in_original_ratio', 0, 'value']);

  return (
    <Container id={id} className="Paragraph ParagraphTextImage">
      <div className={`row ParagraphTextImage__outer ${flipped ? 'flipped' : ''}`}>
        <div className={`col-12 col-md-5 ${wide ? 'col-lg-5' : 'col-lg-4'}`}>
          <Image
            src={displayInOrginalRatio ? imageOriginalScaled : imageSrc}
            className={`ParagraphTextImage__image ${!displayInOrginalRatio && 'ratio_4_3'}`}
          />
          {(caption || imageCaption) && <div className="ParagraphTextImage__caption">{caption || imageCaption}</div>}
        </div>
        <div className={`ParagraphTextImage__text col-12 col-md-7 ${wide ? 'col-lg-7' : 'col-lg-5'}`}>
          {title && (
            <h3 className="ParagraphTextImage__title">{title}</h3>
          )}
          <WysiwygField
            property="schema:text"
            className="ParagraphTextImage__body"
            html={body}
          />
          {link && linkTitle && (
            <Button
              className="ParagraphTextImage__link"
              href={link}
              target={linkTarget}
              primary={false}
            >
              {linkTitle}<span className="icon icon-arrow-right icon-variant-2" />
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphTextImage;
